import { motion } from "framer-motion";
import { useState } from "react";
import BodyPartCards from "./BodyPartCards";
import EnhancedTable from "./EnhancedTable";
import Exercises from "./Exercises";
const HomePage = () => {
  const [selectedBodyPart, setSelectedBodyPart] = useState("");
  const storedData = localStorage.getItem("currentDayData");
  const [currentDayData, setCurrentDayData] = useState(
    storedData ? JSON.parse(storedData) : []
  );

  return (
    <motion.div
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <motion.div
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <BodyPartCards
          handleOnClick={setSelectedBodyPart}
          selectedBodyPart={selectedBodyPart}
        />

        <Exercises
          selectedBodyPart={selectedBodyPart}
          setSelectedBodyPart={setSelectedBodyPart}
          currentDayData={currentDayData}
          setCurrentDayData={setCurrentDayData}
        />

        <EnhancedTable
          currentDayData={currentDayData}
          setCurrentDayData={setCurrentDayData}
        />
      </motion.div>
    </motion.div>
  );
};

export default HomePage;
